module.exports = __webpack_public_path__ + "static/8-2149e098512e3b07a75f9f629be67b6a.png";